<template>
  <ul class="bill-status" :class="{['bill-status_size_'+size]:!!size}">
    <li class="bill-status__item" 
        :class="['bill-status__item_color_'+status.type]"
        v-for="status in value"
        :key="status.id"
        @click="handlChangeStatus"
    >
            <router-link
                :to="{name: 'bill', query: {status: statusList[status.type]}}"
                class="bill-status__label"
                :class="['bill-status__label_color_'+status.type]"
            >
                {{status.value}}
        </router-link>
    </li>
  </ul>
</template>

<script>
import { eventBus } from '@eventBus'
export default {
    props:{
        value:{
            type: Array,
            default: () => []
        },
        size: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            statusList: {
                success: 1,
                danger: 2,
                warning: 3 
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$emit('init')
        })
    },
    methods: {
        handlChangeStatus() {
            eventBus.$emit('changeStatus')
        }
    }

}
</script>

<style lang="scss">
    .bill-status {
        display: flex;
        margin-right: auto;
        gap: 12px;
        
        @media (min-width: 768px) {
            margin-left: 30px;
        }
        @media (min-width: 1500px) {
            gap: 30px;
        }

        &__item {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            &_color{
                &_success {
                    color: #30C66C;
                }
                &_warning {
                    color: #FF9C11;
                }
                &_danger {
                    color: #E94A4A;
                }
            }
        }
        &__label {
            display: flex;
            align-items: center;
            width: fit-content;
            min-width: 18px;
            height: 18px;
            padding: 5px;
            font-size: 12px;
            font-weight: 400;
            border-radius: 14px;
            background: #000;
            color: #fff;
            justify-content: center;
            @media (min-width: 768px) {
                min-width: 26px;
                height: 26px;
                padding: 8px;
                font-size: 16px;
            }

            &_color{
                &_success {
                    background-color: #30C66C;
                }
                &_warning {
                    background-color: #FF9C11;
                }
                &_danger {
                    background-color: #E94A4A;
                }
            }
        }

        &_size_small &{
            &__item {
                font-size: 0;
            }
        }
    }
</style>